import * as React from 'react';
import classnames from 'classnames';
import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { IModalDimensions } from '../../../../../modules/mfrm-buybox/components/buybox-product-configure-mfrm';
export interface IMfrmModalDrawerViewProps {
  isOpen?: boolean;
  className?: string;
  isMobile: boolean;
  distinctClassName: string;
  modalDimensions?: IModalDimensions[];
  preSelection?: IModalDimensions;
  onClickBaseFunc?(): void;
  onCloseModal?(): void;
  title: string;
  subtitle: string;
}

const AdjustableBaseModal: React.FC<IMfrmModalDrawerViewProps> = props => {
  return (
    <Modal
      autoFocus={true}
      fade={false}
      isOpen={props.isOpen}
      horizontalPosition={props.isMobile ? 'center' : 'right'}
      verticalPosition={props.isMobile ? 'center' : 'top'}
      zIndex={5003}
      toggle={props.onCloseModal}
      applicationNode={'rsg-root'}
      modalClassName={
        classnames(
          props.isMobile
            ? `modal-buybox-mobile ${props.distinctClassName}`
            : `modal-buybox-desktop ${props.distinctClassName}`,
          !props.isOpen && 'not-shown'
        )
      }
    >
      <ModalHeader toggle={props.onCloseModal} />
      <ModalBody>
        <h2 className="msc-title">{props.title}</h2>
        <p className="adj-base-subtitle">{props.subtitle}</p>
        {props.children}
      </ModalBody>
    </Modal>
  );
};

export default AdjustableBaseModal;
